/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.TEXT.FIELDSETHEADING,
    name: "driversLicenceTitle",
    label: "Australian driver licence"
  },
  {
    fieldType: FIELD.TEXT.PARAGRAPH,
    name: "driversLicenceIntroduction",
    description: [
      "All fields with an asterisk are required."
    ]
  },
  {
    fieldType: FIELD.INPUT.DROPDOWN,
    name: "greenid_regodvs_state",
    label: "State of issue",
    fieldRequired: true,
    options: [
      { text: "ACT", value: "actregodvs" },
      { text: "NSW", value: "nswregodvs" },
      { text: "NT", value: "ntregodvs" },
      { text: "SA", value: "saregodvs" },
      { text: "QLD", value: "qldregodvs" },
      { text: "TAS", value: "tasregodvs" },
      { text: "VIC", value: "vicregodvs" },
      { text: "WA", value: "waregodvs" }
    ]
  }
];